<script setup lang="ts">
  import { useCookies } from '@bv/composables';
  import { useSettingsStore, useUserStore } from '@bv/stores';
  import { watch, toRef, ref } from 'vue';

  import { registerFcmToken } from '@/plugins/firebase';

  import CallPopupManager from './components/call-center/inbound-calls/CallPopupManager.vue';
  import { useCallCenterStore } from './stores/call-center/call-center.store';

  const userStore = useUserStore();
  const settingsStore = useSettingsStore();
  const callCenterStore = useCallCenterStore();
  const userDetails = toRef(userStore, 'userDetails');

  watch(
    userDetails,
    (newUser) => {
      // for now only
      const recentService = userDetails.value?.recent_service;
      const workspaceId = recentService ? userDetails.value?.recent_workspaces?.[recentService] : undefined;

      if (
        workspaceId &&
        [
          '9d15f015-7ef0-4c49-9832-d16f1ad14b66',
          '61b8ca2b-0228-4da0-8ef4-a80fc50ba28f',
          '9d098fbd-6194-4756-b50e-5432a3e6fb12',
        ].includes(workspaceId)
      ) {
        const initial = useCookies().get('bv-setting');
        const layoutType = ref(initial?.layout_type ?? 'new');
        settingsStore.setLayoutType(layoutType.value);
      }

      if (newUser && newUser.id) {
        registerFcmToken();
        callCenterStore.isAnyVoipChannelConnected();
      }
    },
    { immediate: true },
  );
</script>

<template>
  <bv-view />

  <!-- general inbound calls popups -->
  <call-popup-manager />
</template>
